import React from 'react'
import PropTypes from 'prop-types'

class ClassEngagement extends React.Component {
  componentDidMount() {
    // Set up jQuery for knobs
    $('.analytics_knob > input').knob({
      readOnly: true,
      format: function (value) {
        return value + '%'
      },
    })
  }

  render() {
    let id = `${this.props.title}-progress-knob`
    let label = id + '-label'
    return (
      <div className="d-flex flex-column-reverse flex-md-row m-1 align-items-center justify-content-start">
        <div className="analytics_knob my-3">
          <input
            id={id}
            className="shadow-none"
            type="text"
            value={this.props.value + '%'}
            data-inputcolor={this.props.color[0]}
            data-fgcolor={this.props.color[1]}
            data-width="250"
            data-height="250"
            readOnly
            aria-labelledby={label}
          />
        </div>
        <span id={label} className="analytics_text">{this.props.title}</span>
      </div>
    )
  }
}

ClassEngagement.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  color: PropTypes.array.isRequired,
}

export default ClassEngagement
